module.exports = __webpack_public_path__ + "static/media/Bell-Notifications-Grey.ca5d67c0.png";